// extracted by mini-css-extract-plugin
export default {"wrapper":"SomethingWentWrong_wrapper__LWSkR","label":"SomethingWentWrong_label__38ZCp"};